import iconData from '../mockup/amenitiesiconData';

const features = () => {

    const iconKeys = Object.keys(iconData);

    return (
        <React.Fragment>
            {
                iconKeys.map(key => {

                    const {
                        className = '',
                        popover = '',
                        featureName = '',
                        description = '',
                        learnMore = '',

                    } = iconData[key];

                    return (
                        <div key={ key } id={ popover } className="hide">
                          <div className="popover-content-wrap">
                              <div className="popover-section-icon">
                                <span className={`ic ${ className }`}>
                                    <span className="sr-only">{ featureName }</span>
                                </span>
                              </div>
                              <div className="popover-section-content">
                                    <h2>{featureName}</h2>
                                    <p>{description}</p>
                                    {
                                        learnMore &&
                                        <p>
                                            <a className="link-more" href={learnMore}>
                                                Learn More
                                            </a>
                                        </p>
                                    }
                              </div>
                          </div>
                        </div>
                    );
                })
            }
        </React.Fragment>
    );
};

export default features;
